declare global {
  interface Window {
    /**
     * Set by the mobile app's WebView via `injectedJavaScriptBeforeContentLoaded`.
     * Used as the primary signal that we're running embedded inside the native app.
     */
    __INFINEX_EMBEDDED__?: boolean;
  }
}

/**
 * Returns true when running inside the Infinex mobile app's WebView.
 * Checks for `window.__INFINEX_EMBEDDED__` — a flag explicitly set by the
 * native app before any page content loads.
 */
export function isNativeWebView(): boolean {
  return typeof window !== 'undefined' && window.__INFINEX_EMBEDDED__ === true;
}
